import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "common/locales";

interface ConfirmDeleteDialogProps {
  dialogOpen: boolean;
  deletedObjectDescription: string;
  closeDialog: () => void;
  onConfirmDelete: () => void;
}

export default function ConfirmDeleteDialog(props: ConfirmDeleteDialogProps) {
  const { onConfirmDelete, dialogOpen, closeDialog, deletedObjectDescription } =
    props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={dialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"xs"}
    >
      <DialogTitle id="alert-dialog-title">
        {t("confirmdeletedialog.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t("confirmdeletedialog.text", {
            fileName: deletedObjectDescription,
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onConfirmDelete();
            closeDialog();
          }}
          color="secondary"
        >
          {t("confirmdeletedialog.confirm.label")}
        </Button>
        <Button
          onClick={() => {
            closeDialog();
          }}
          color="primary"
          autoFocus
        >
          {t("confirmdeletedialog.cancel.label")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
